<div class="checkbox">
  <h3-disable-with-tooltip-helper [disable]="disable">
    <label [class.muted]="disable">
      <input type="checkbox" [formControl]="control" />
      <ng-content></ng-content>
    </label>
  </h3-disable-with-tooltip-helper>
</div>
